import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import { createSelector } from "keautils";
import { ImportesPPView } from "../../../../catalogos/items/tarifapp/edit/importes/view";
import { componentToRx } from "app/main/std";
interface Props {
    value: models.PrecioPaquetePP;
}

class PrecioPaquetePPNoRx extends React.PureComponent<Props> {

    render() {
        const x = this.props.value;
        return (
            <kea.Panel title="Importes">
                <h3>
                    Total:
                    <b>{kea.formatCurrency(x.Total)}</b>
                </h3>
                <h4>
                    Cant. guias:
                    <b>{x.CantGuias}</b>
                </h4>
                <h4>
                    Descuento:
                    <b>{kea.formatPercent(x.Descuento)}</b>
                </h4>

                <ImportesPPView value={x.ImportesGuia}  />
            </kea.Panel>
        )
    }
}

export const PrecioPaquetePP = componentToRx(PrecioPaquetePPNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/paquetespp/edit/precio.tsx